<template>
  <div class="login">
    <div v-if="!this.isAuthenticated">
    <form class="login-form">
      <br>
      <div class="spacer"></div>
      <label for="username">Nom d’utilisateur</label><br>
      <div class="spacer"></div>
      <input type="text" name="username" v-model="username"/><br>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <label for="password">Mot de passe</label><br>
      <div class="spacer"></div>
      <input type="password" name="password" v-model="password"/><br>
      <br>
      <button class="btn normal" @click.prevent="login">Login</button><br>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <router-link :to="{path:'/'}">Page d’accueil</router-link>
      <div class="spacer"></div>
      <div class="spacer"></div>
    </form>
    </div>
    <div v-else>
    <form class="login-form">
      <br><small>Hello {{userAuthenticated}}. Vous êtes connecté !</small><br><br>
      <button class="btn normal" @click.prevent="logout">Se déconnecter </button><br><br>
      <router-link :to="{path:'/'}">Page d’accueil</router-link>
      <div class="spacer"></div>
      <div class="spacer"></div>      
    </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Main from './Main'

export default {
  name: 'LoginForm',
  data () {
    return {
      username: undefined,
      password: undefined
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userAuthenticated'
    ])
  },
  components: {
    Main
  },
  methods: {
    login () {
      const username = this.username
      const password = this.password
      this.$store.dispatch('authRequest', { username, password })
      .then(response => {
        console.log('gotoHome')
        // retour au site en mode connecté
      })
      .catch(() => {
        console.log('oups')
        // erreur : non connecté
      })
    },
    logout () {
      this.$store.dispatch('authLogout')
    }

  }
}
</script>

<style scoped>

.login {
  position: absolute;
  height:100%;
  width: 100%;
}

.login-form {
    position: fixed;
    width: 300px;
    background: #fff;
    z-index: 99;
    text-align: center;
    left: 50%;
    top: 30%;
    margin-left: -150px;
    border: 3px solid black;
}

.hub{
  opacity: 0.75;
}

.login-form input {
    width: 95%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
    text-align: center;
    font-weight: bold;

}



</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue